import React from 'react';
import { useTranslation } from 'react-i18next';
import './ValueProps.css';

export const ValueProps: React.FC = () => {
  const { t } = useTranslation();
  const highlights = [
    { icon: '📱', key: 'noPhoneBill' },
    { icon: '📄', key: 'docScanning' },
    { icon: '🚨', key: 'emergency' },
    { icon: '🤝', key: 'volunteer' },
    { icon: '🔒', key: 'privacy' },
    { icon: '📍', key: 'location' },
  ];
  const pills = ['largeText', 'simpleNav', 'checkins', 'screenShare', 'radio', 'battery'];

  return (
    <section className="value-props-section">
      <div className="value-props-container">
        <h2 className="value-props-title">{t('valueProps.title')}</h2>

        <div className="highlights-grid">
          {highlights.map((item) => (
            <div key={item.key} className="highlight-card">
              <div className="highlight-icon">{item.icon}</div>
              <h3 className="highlight-title">{t(`valueProps.highlights.${item.key}.title`)}</h3>
              <p className="highlight-text">{t(`valueProps.highlights.${item.key}.text`)}</p>
            </div>
          ))}
        </div>

        <div className="additional-features">
          {pills.map((pill) => (
            <p key={pill} className="feature-pill">✓ {t(`valueProps.pills.${pill}`)}</p>
          ))}
        </div>
      </div>
    </section>
  );
};
